// https://github.com/tailwindlabs/tailwindcss/blob/master/stubs/defaultConfig.stub.js
import tailwindConfig from '@acv/shared-vuejs/dist/tailwind.config';

// tailwindConfig file coming from the shared-vuejs library is using a different version.
// It just removes these properties in order to prevent warning userMessages.
delete tailwindConfig.purge;
delete tailwindConfig.darkMode;
const config = {
  presets: [
    tailwindConfig,
  ],
  theme: {
    extend: {
      colors: {
        // Auction status pill fills (Figma "Auction Badges — Color Review", Proposal B)
        'auction-badge': {
          'high-bidder': '#00704F',
          'out-bid': '#CC3838',
          'pending-proxy': '#00558C',
          finalize: '#1B1D1F',
          'near-reserve': '#71747A',
        },
      },
    },
  },
  content: [
    './src/**/*.html',
    './public/**/*.html',
    './src/**/*.vue',
    './src/**/*.js',
  ],
};

export default config;
